'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { AVATAR_SIZES, AVATAR_TYPES, AVATAR_TYPE_ICONS, SOCIAL_MAP } from '../Constants';
import AvatarContentHolder from './baseStyledComponents/AvatarContentHolder';
import AvatarWrapper from './baseStyledComponents/AvatarWrapper';
import AvatarWrapperOverlay from './baseStyledComponents/AvatarWrapperOverlay';
import PropTypes from 'prop-types';
import { Component } from 'react';
import SocialBadge from './baseStyledComponents/SocialBadge';
import SVGIcon from './baseStyledComponents/SVGIcon';
import SVGIconEdit from './baseStyledComponents/SVGIconEdit';
import SVGImage from './baseStyledComponents/SVGImage';
import SVGText from './baseStyledComponents/SVGText';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITruncateString from 'UIComponents/text/UITruncateString';

function delayUntilIdle(callback) {
  const delay = window.requestIdleCallback || window.setTimeout;
  const delayOptions = delay === window.requestIdleCallback ? {
    timeout: 5000
  } : 1000;
  const id = delay(callback, delayOptions);
  return window.requestIdleCallback ? () => window.cancelIdleCallback(id) : () => window.clearTimeout(id);
}

class UIAvatarDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownMenuOpen: false,
      isTooltipLoaded: false
    };
  }

  componentDidMount() {
    this.cancelTimeout = delayUntilIdle(() => this.setState({
      isTooltipLoaded: true
    }));
  }

  componentWillUnmount() {
    this.cancelTimeout();
  }

  handleMouseEnter() {
    this.setState(() => ({
      isDropdownMenuOpen: true
    }));
  }

  getDefaultAvatar(type) {
    const options = {
      [AVATAR_TYPES.contact]: 'https://static.hsappstatic.net/salesImages/static-1.362/avatars/default-avatar.png',
      [AVATAR_TYPES.company]: 'https://static.hsappstatic.net/salesImages/static-1.362/avatars/default-company-avatar.png'
    };
    return options[type];
  }

  MaybeAvatarHover(_ref) {
    let {
      _isHasTooltip,
      _isHoverlayOpen,
      _isListReversed,
      _isTooltipLoaded = false,
      className,
      outerChildren,
      isHoverlay,
      size,
      style,
      toolTipName,
      toolTipPlacement
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["_isHasTooltip", "_isHoverlayOpen", "_isListReversed", "_isTooltipLoaded", "className", "outerChildren", "isHoverlay", "size", "style", "toolTipName", "toolTipPlacement"]);

    className = className || '';
    className = _isHoverlayOpen ? `${className} hover-test` : className;
    const sizeStyle = size && size !== AVATAR_SIZES.responsive ? {
      width: `${size}px`
    } : {
      width: '100%'
    };
    const calculatedOverlayOffset = {
      overlapOffset: (size || 40) * 0.15
    };
    style = Object.assign({}, style, sizeStyle);
    const AvatarWrapperProps = Object.assign({
      _isListReversed,
      className,
      style
    }, calculatedOverlayOffset, rest);

    if (!isHoverlay && !_isHoverlayOpen && _isHasTooltip) {
      return outerChildren && !_isTooltipLoaded ? /*#__PURE__*/_jsx(AvatarWrapper, Object.assign({}, AvatarWrapperProps)) : /*#__PURE__*/_jsx(UITooltip, {
        title: toolTipName,
        placement: toolTipPlacement,
        children: /*#__PURE__*/_jsx(AvatarWrapper, Object.assign({}, AvatarWrapperProps))
      });
    }

    return /*#__PURE__*/_jsx(AvatarWrapperOverlay, Object.assign({}, AvatarWrapperProps));
  }

  tryToGetANameOutOfEmailAddress(aString) {
    if (!aString || !aString.indexOf('@')) {
      return aString;
    }

    return aString.split('_').join(' ');
  }

  isLatinCharacters(aString) {
    const nonLatin = /[^\u0020-\u01BF]/;
    return nonLatin.test(aString);
  }

  displayNameToInitials(aString, passed) {
    const {
      displayName,
      _isHasMore,
      _isListReversed,
      size,
      type
    } = this.props;

    if (passed || !aString || typeof aString !== 'string') {
      return /*#__PURE__*/_jsx(SVGImage, Object.assign({}, {
        size,
        _isListReversed,
        src: this.getDefaultAvatar(AVATAR_TYPES[type])
      }));
    }

    if (!aString || this.isLatinCharacters(aString) && !passed) {
      return this.displayNameToInitials(this.tryToGetANameOutOfEmailAddress(displayName), true);
    }

    const names = aString.split(' ');
    let initials = names[0].substring(0, 1);

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1);
    }

    return /*#__PURE__*/_jsx(SVGText, {
      wrapperProps: {
        _isHasMore
      },
      y: "55",
      children: initials
    });
  }

  renderOverlay() {
    const {
      isHoverlay,
      _isHoverlayOpen,
      size
    } = this.props;
    const isRenderingOverlay = !!isHoverlay || !!_isHoverlayOpen;
    return isRenderingOverlay && /*#__PURE__*/_jsx(SVGIconEdit, {
      wrapperProps: {
        onMouseEnter: () => this.handleMouseEnter(),
        onClick: () => {},
        size
      },
      size: AVATAR_SIZES[size]
    });
  }

  renderAvatarImageOrText() {
    const {
      src,
      displayName,
      type,
      _isHasMore,
      size
    } = this.props;

    if (src) {
      return /*#__PURE__*/_jsx(SVGImage, {
        size: size,
        src: src
      });
    }

    if (AVATAR_TYPES[type] === AVATAR_TYPES.company) {
      return /*#__PURE__*/_jsx(SVGImage, {
        size: size,
        src: this.getDefaultAvatar(AVATAR_TYPES.company)
      });
    }

    if (_isHasMore || AVATAR_TYPES[type] === AVATAR_TYPES.contact || AVATAR_TYPES[type] === AVATAR_TYPES.company) {
      return this.displayNameToInitials(displayName);
    }

    return /*#__PURE__*/_jsx(SVGIcon, {
      wrapperProps: {
        size
      },
      y: 65,
      icon: AVATAR_TYPE_ICONS[AVATAR_TYPES[type]]
    });
  }

  renderSocialBadge(socialNetwork) {
    if (!socialNetwork) {
      return undefined;
    }

    return /*#__PURE__*/_jsx(SocialBadge, {
      socialNetwork: socialNetwork
    });
  }

  renderContentAndOverlay() {
    const {
      href,
      _isListReversed,
      size,
      type
    } = this.props;
    return /*#__PURE__*/_jsxs(AvatarContentHolder, {
      _isListReversed: _isListReversed,
      size: size,
      href: href,
      type: type,
      children: [this.renderAvatarImageOrText(), this.renderOverlay()]
    });
  }

  renderAvatarContent(SwitchComponent, props, socialNetwork) {
    return /*#__PURE__*/_jsxs(SwitchComponent, Object.assign({}, props, {
      children: [this.renderContentAndOverlay(), this.renderSocialBadge(socialNetwork)]
    }));
  }

  render() {
    const {
      MaybeAvatarHover,
      props
    } = this;
    const {
      _isHasTooltip,
      _isHasMore,
      _isHoverlayOpen,
      _isListReversed,
      _toolTipOverWrite,
      className,
      children,
      displayName,
      isHoverlay,
      onClick,
      size,
      socialNetwork,
      style,
      textSpacing,
      truncateLength,
      toolTipPlacement
    } = props;
    const maybeWrapperProps = {
      _isHasTooltip,
      _isHasMore,
      _isHoverlayOpen,
      _isListReversed,
      _isTooltipLoaded: this.state.isTooltipLoaded,
      className,
      outerChildren: children,
      displayName,
      isHoverlay,
      onClick,
      size: AVATAR_SIZES[size],
      style,
      toolTipName: _toolTipOverWrite || displayName,
      toolTipPlacement
    };
    const avatarComponent = this.renderAvatarContent(MaybeAvatarHover, maybeWrapperProps, socialNetwork);
    return children ? /*#__PURE__*/_jsx(UITruncateString, {
      onClick: onClick,
      maxWidth: truncateLength,
      children: /*#__PURE__*/_jsxs("span", {
        className: "align-center",
        children: [avatarComponent, /*#__PURE__*/_jsx("span", {
          className: `m-left-${textSpacing}`,
          children: children
        })]
      })
    }) : avatarComponent;
  }

}

UIAvatarDisplay.propTypes = {
  _isHasMore: PropTypes.bool,
  _isHasTooltip: PropTypes.bool,
  _isHoverlayOpen: PropTypes.bool,
  _isListReversed: PropTypes.bool,
  _toolTipOverWrite: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.any,
  href: PropTypes.string,
  isHoverlay: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(Object.keys(AVATAR_SIZES)),
  socialNetwork: PropTypes.oneOf(Object.keys(SOCIAL_MAP)),
  src: SVGImage.propTypes.image,
  type: PropTypes.oneOf(Object.keys(AVATAR_TYPES)),
  textSpacing: PropTypes.number,
  truncateLength: PropTypes.number,
  toolTipPlacement: PropTypes.string
};
UIAvatarDisplay.defaultProps = {
  _isHasMore: false,
  _isHasTooltip: true,
  _isListReversed: false,
  _isHoverLayOpen: false,
  size: 'sm',
  textSpacing: 3,
  truncateLength: 200
};
export default UIAvatarDisplay;